import React from 'react';

interface LockSVGProps {
    color: string;
}

const LockSVG: React.FC<LockSVGProps> = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" fill="none"><path fill={color} fillRule="evenodd" d="M5 2.714c-.92 0-1.667.768-1.667 1.715v.857h3.334v-.857c0-.947-.747-1.715-1.667-1.715ZM1.667 4.43v.857H1.25C.56 5.286 0 5.86 0 6.57v5.143C0 12.424.56 13 1.25 13h7.5c.69 0 1.25-.576 1.25-1.286V6.571c0-.71-.56-1.285-1.25-1.285h-.417v-.857C8.333 2.535 6.841 1 5 1 3.159 1 1.667 2.535 1.667 4.429ZM5 10.214c.575 0 1.042-.48 1.042-1.071C6.042 8.55 5.575 8.07 5 8.07s-1.042.48-1.042 1.072c0 .592.467 1.071 1.042 1.071Z" clipRule="evenodd" /></svg>
);

export default LockSVG;